import { render, staticRenderFns } from "./PlanSettingDetail.vue?vue&type=template&id=574c8452&scoped=true"
import script from "./PlanSettingDetail.vue?vue&type=script&lang=js"
export * from "./PlanSettingDetail.vue?vue&type=script&lang=js"
import style0 from "./PlanSettingDetail.vue?vue&type=style&index=0&id=574c8452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c8452",
  null
  
)

export default component.exports